import { Button, ButtonProps } from "@repo/ui/components/ui/button"
import { formContext } from "@repo/ui/tanstack-form"
import * as React from "react"

interface SubmitButtonProps extends ButtonProps {
  children?: React.ReactNode
}

export function SubmitButton({
  children = "Submit",
  disabled,
  ...props
}: SubmitButtonProps) {
  const form = React.useContext(formContext)

  const isSubmitting = form.state.isSubmitting
  const cannotSubmit = !form.state.canSubmit

  return (
    <Button
      type="submit"
      disabled={disabled || cannotSubmit || isSubmitting}
      loading={isSubmitting}
      {...props}
    >
      {children}
    </Button>
  )
}
